/* @flow */
import React from 'react';
import Select from 'components/Select.jsx';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const NO_SUBJECT_CODE = 'no_subject';

type Props = {
  initialSubject: ?string,
  onChange: (subject: ?string) => void,
  subjects: Object[],
}

type State = {
  selectedSubject: ?string,
};

export class SubjectPicker extends React.Component {
  props: Props;
  state: State = {
    selectedSubject: this.props.initialSubject,
  };

  setSubject = (subject: string) => {
    this.setState({ selectedSubject: subject });
    const subjectCode = subject === NO_SUBJECT_CODE ? null : subject;
    this.props.onChange(subjectCode);
  }

  render() {
    const subjects = this.props.subjects.map(s => ({ value: s.subject_code, label: s.name }));
    const options = [{ value: NO_SUBJECT_CODE, label: 'No subject' }, ...subjects];

    return (
      <Select
        options={options}
        onChange={this.setSubject}
        value={this.state.selectedSubject}
        searchable
      />
    );
  }
}

const withSubjects = graphql(gql`
  query {
    settings {
      class {
        subjects {
          subject_code
          name
        }
      }
    }
  }
  `,
  {
    props: ({ data }) => ({
      subjects: data.settings ? data.settings.class.subjects : [],
    }),
  }
);

export default withSubjects(SubjectPicker);




// WEBPACK FOOTER //
// ./src/components/SubjectPicker.jsx